// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.35.0
// source: asset_instrument.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire'

export const protobufPackage = 'intent_compiler'

export enum ProductKind {
  PRODUCT_KIND_UNSPECIFIED = 0,
  PRODUCT_KIND_SPOT = 1,
  PRODUCT_KIND_PERPETUAL = 2,
  /** PRODUCT_KIND_FUTURE - Dated (expiring) future. */
  PRODUCT_KIND_FUTURE = 3,
  UNRECOGNIZED = -1,
}

export function productKindFromJSON(object: any): ProductKind {
  switch (object) {
    case 0:
    case 'PRODUCT_KIND_UNSPECIFIED':
      return ProductKind.PRODUCT_KIND_UNSPECIFIED
    case 1:
    case 'PRODUCT_KIND_SPOT':
      return ProductKind.PRODUCT_KIND_SPOT
    case 2:
    case 'PRODUCT_KIND_PERPETUAL':
      return ProductKind.PRODUCT_KIND_PERPETUAL
    case 3:
    case 'PRODUCT_KIND_FUTURE':
      return ProductKind.PRODUCT_KIND_FUTURE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ProductKind.UNRECOGNIZED
  }
}

export function productKindToJSON(object: ProductKind): string {
  switch (object) {
    case ProductKind.PRODUCT_KIND_UNSPECIFIED:
      return 'PRODUCT_KIND_UNSPECIFIED'
    case ProductKind.PRODUCT_KIND_SPOT:
      return 'PRODUCT_KIND_SPOT'
    case ProductKind.PRODUCT_KIND_PERPETUAL:
      return 'PRODUCT_KIND_PERPETUAL'
    case ProductKind.PRODUCT_KIND_FUTURE:
      return 'PRODUCT_KIND_FUTURE'
    case ProductKind.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TenorUnit {
  TENOR_UNIT_UNSPECIFIED = 0,
  TENOR_UNIT_DAYS = 1,
  TENOR_UNIT_WEEKS = 2,
  TENOR_UNIT_MONTHS = 3,
  TENOR_UNIT_YEARS = 4,
  UNRECOGNIZED = -1,
}

export function tenorUnitFromJSON(object: any): TenorUnit {
  switch (object) {
    case 0:
    case 'TENOR_UNIT_UNSPECIFIED':
      return TenorUnit.TENOR_UNIT_UNSPECIFIED
    case 1:
    case 'TENOR_UNIT_DAYS':
      return TenorUnit.TENOR_UNIT_DAYS
    case 2:
    case 'TENOR_UNIT_WEEKS':
      return TenorUnit.TENOR_UNIT_WEEKS
    case 3:
    case 'TENOR_UNIT_MONTHS':
      return TenorUnit.TENOR_UNIT_MONTHS
    case 4:
    case 'TENOR_UNIT_YEARS':
      return TenorUnit.TENOR_UNIT_YEARS
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TenorUnit.UNRECOGNIZED
  }
}

export function tenorUnitToJSON(object: TenorUnit): string {
  switch (object) {
    case TenorUnit.TENOR_UNIT_UNSPECIFIED:
      return 'TENOR_UNIT_UNSPECIFIED'
    case TenorUnit.TENOR_UNIT_DAYS:
      return 'TENOR_UNIT_DAYS'
    case TenorUnit.TENOR_UNIT_WEEKS:
      return 'TENOR_UNIT_WEEKS'
    case TenorUnit.TENOR_UNIT_MONTHS:
      return 'TENOR_UNIT_MONTHS'
    case TenorUnit.TENOR_UNIT_YEARS:
      return 'TENOR_UNIT_YEARS'
    case TenorUnit.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

/**
 * A non-option instrument named by its asset ("BTC", "TSLA", "xyz:TSLA"),
 * matched case-insensitively against the catalog's base asset and native
 * venue name. Several matches are narrowed by `product`, then (dated futures)
 * `expiry`, then a venue rule: the spot quote preference, or Hyperliquid's
 * main-dex perp over HIP-3 listings. Still several is refused as
 * AMBIGUOUS_INSTRUMENT with the listed candidates; none is refused as not
 * listed. A stated product that is not listed, without an expiry, falls back
 * to the asset's other listings when they are all one product, with
 * WARNING_CODE_PRODUCT_SUBSTITUTED; otherwise it is refused naming them.
 * Options use OptionSelector.
 */
export interface AssetInstrument {
  asset: string
  /**
   * Only what the user stated; UNSPECIFIED when they named no product. An
   * Acquire SELL with UNSPECIFIED resolves to spot when the account holds the
   * asset, else to its perpetual with WARNING_CODE_SELL_OPENS_SHORT.
   */
  product: ProductKind
  /**
   * PRODUCT_KIND_FUTURE only: which listed expiry. Refused with any other
   * product.
   */
  expiry?: ExpirySpec | undefined
}

export interface ExpirySpec {
  unixMs?: string | undefined
  /**
   * YYYY-MM-DD in the venue's settlement timezone; resolves to the venue's
   * settlement instant on that date. Refused with `INVALID_EXPIRY` when no
   * listed contract matches.
   */
  date?: string | undefined
  /**
   * Relative expiry selector from compiler evaluation time. Example:
   * value=2, unit=TENOR_UNIT_WEEKS means "about two weeks out".
   */
  tenor?: TenorSpec | undefined
  nearest?: NearestExpiry | undefined
  month?: MonthExpiry | undefined
  weekday?: WeekdayExpiry | undefined
}

export interface TenorSpec {
  /** Positive duration amount in the selected unit. */
  value: number
  unit: TenorUnit
}

/** Resolves to the LAST listed expiry in that month (the venue's monthly); refused with `INVALID_EXPIRY` when none is listed. */
export interface MonthExpiry {
  /** 1-12. */
  month: number
  /** When omitted, the next occurrence of that month from compiler evaluation time; the current month counts while it still has a listed expiry ahead. */
  year?: number | undefined
}

/** Resolves to the listed expiry on that weekday's date. A day with no listed contract is refused as the `date` arm refuses it; `INVALID_EXPIRY` when weekday is outside 1-7, or when weeks_ahead names a day, or an expiry, already past. */
export interface WeekdayExpiry {
  /** ISO weekday, 1 = Monday .. 7 = Sunday. */
  weekday: number
  /** Calendar weeks after the current one (ISO, Monday start): 0 = this week's, 1 = next week's. When omitted, the next occurrence of that weekday after compiler evaluation time. */
  weeksAhead?: number | undefined
}

export interface NearestExpiry {
  /** Calendar-day window from compiler evaluation time. */
  minDays?: string | undefined
  maxDays?: string | undefined
}

function createBaseAssetInstrument(): AssetInstrument {
  return { asset: '', product: 0, expiry: undefined }
}

export const AssetInstrument: MessageFns<AssetInstrument> = {
  encode(message: AssetInstrument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.asset !== '') {
      writer.uint32(10).string(message.asset)
    }
    if (message.product !== 0) {
      writer.uint32(16).int32(message.product)
    }
    if (message.expiry !== undefined) {
      ExpirySpec.encode(message.expiry, writer.uint32(26).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssetInstrument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAssetInstrument()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break
          }

          message.asset = reader.string()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.product = reader.int32() as any
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.expiry = ExpirySpec.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AssetInstrument {
    return {
      asset: isSet(object.asset) ? globalThis.String(object.asset) : '',
      product: isSet(object.product) ? productKindFromJSON(object.product) : 0,
      expiry: isSet(object.expiry) ? ExpirySpec.fromJSON(object.expiry) : undefined,
    }
  },

  toJSON(message: AssetInstrument): unknown {
    const obj: any = {}
    if (message.asset !== '') {
      obj.asset = message.asset
    }
    if (message.product !== 0) {
      obj.product = productKindToJSON(message.product)
    }
    if (message.expiry !== undefined) {
      obj.expiry = ExpirySpec.toJSON(message.expiry)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AssetInstrument>, I>>(base?: I): AssetInstrument {
    return AssetInstrument.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AssetInstrument>, I>>(object: I): AssetInstrument {
    const message = createBaseAssetInstrument()
    message.asset = object.asset ?? ''
    message.product = object.product ?? 0
    message.expiry =
      object.expiry !== undefined && object.expiry !== null
        ? ExpirySpec.fromPartial(object.expiry)
        : undefined
    return message
  },
}

function createBaseExpirySpec(): ExpirySpec {
  return {
    unixMs: undefined,
    date: undefined,
    tenor: undefined,
    nearest: undefined,
    month: undefined,
    weekday: undefined,
  }
}

export const ExpirySpec: MessageFns<ExpirySpec> = {
  encode(message: ExpirySpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.unixMs !== undefined) {
      writer.uint32(8).int64(message.unixMs)
    }
    if (message.date !== undefined) {
      writer.uint32(18).string(message.date)
    }
    if (message.tenor !== undefined) {
      TenorSpec.encode(message.tenor, writer.uint32(26).fork()).join()
    }
    if (message.nearest !== undefined) {
      NearestExpiry.encode(message.nearest, writer.uint32(42).fork()).join()
    }
    if (message.month !== undefined) {
      MonthExpiry.encode(message.month, writer.uint32(50).fork()).join()
    }
    if (message.weekday !== undefined) {
      WeekdayExpiry.encode(message.weekday, writer.uint32(58).fork()).join()
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExpirySpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseExpirySpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.unixMs = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 18) {
            break
          }

          message.date = reader.string()
          continue
        }
        case 3: {
          if (tag !== 26) {
            break
          }

          message.tenor = TenorSpec.decode(reader, reader.uint32())
          continue
        }
        case 5: {
          if (tag !== 42) {
            break
          }

          message.nearest = NearestExpiry.decode(reader, reader.uint32())
          continue
        }
        case 6: {
          if (tag !== 50) {
            break
          }

          message.month = MonthExpiry.decode(reader, reader.uint32())
          continue
        }
        case 7: {
          if (tag !== 58) {
            break
          }

          message.weekday = WeekdayExpiry.decode(reader, reader.uint32())
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ExpirySpec {
    return {
      unixMs: isSet(object.unixMs)
        ? globalThis.String(object.unixMs)
        : isSet(object.unix_ms)
          ? globalThis.String(object.unix_ms)
          : undefined,
      date: isSet(object.date) ? globalThis.String(object.date) : undefined,
      tenor: isSet(object.tenor) ? TenorSpec.fromJSON(object.tenor) : undefined,
      nearest: isSet(object.nearest) ? NearestExpiry.fromJSON(object.nearest) : undefined,
      month: isSet(object.month) ? MonthExpiry.fromJSON(object.month) : undefined,
      weekday: isSet(object.weekday) ? WeekdayExpiry.fromJSON(object.weekday) : undefined,
    }
  },

  toJSON(message: ExpirySpec): unknown {
    const obj: any = {}
    if (message.unixMs !== undefined) {
      obj.unixMs = message.unixMs
    }
    if (message.date !== undefined) {
      obj.date = message.date
    }
    if (message.tenor !== undefined) {
      obj.tenor = TenorSpec.toJSON(message.tenor)
    }
    if (message.nearest !== undefined) {
      obj.nearest = NearestExpiry.toJSON(message.nearest)
    }
    if (message.month !== undefined) {
      obj.month = MonthExpiry.toJSON(message.month)
    }
    if (message.weekday !== undefined) {
      obj.weekday = WeekdayExpiry.toJSON(message.weekday)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ExpirySpec>, I>>(base?: I): ExpirySpec {
    return ExpirySpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ExpirySpec>, I>>(object: I): ExpirySpec {
    const message = createBaseExpirySpec()
    message.unixMs = object.unixMs ?? undefined
    message.date = object.date ?? undefined
    message.tenor =
      object.tenor !== undefined && object.tenor !== null
        ? TenorSpec.fromPartial(object.tenor)
        : undefined
    message.nearest =
      object.nearest !== undefined && object.nearest !== null
        ? NearestExpiry.fromPartial(object.nearest)
        : undefined
    message.month =
      object.month !== undefined && object.month !== null
        ? MonthExpiry.fromPartial(object.month)
        : undefined
    message.weekday =
      object.weekday !== undefined && object.weekday !== null
        ? WeekdayExpiry.fromPartial(object.weekday)
        : undefined
    return message
  },
}

function createBaseTenorSpec(): TenorSpec {
  return { value: 0, unit: 0 }
}

export const TenorSpec: MessageFns<TenorSpec> = {
  encode(message: TenorSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== 0) {
      writer.uint32(8).uint32(message.value)
    }
    if (message.unit !== 0) {
      writer.uint32(16).int32(message.unit)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TenorSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTenorSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.value = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.unit = reader.int32() as any
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TenorSpec {
    return {
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
      unit: isSet(object.unit) ? tenorUnitFromJSON(object.unit) : 0,
    }
  },

  toJSON(message: TenorSpec): unknown {
    const obj: any = {}
    if (message.value !== 0) {
      obj.value = Math.round(message.value)
    }
    if (message.unit !== 0) {
      obj.unit = tenorUnitToJSON(message.unit)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TenorSpec>, I>>(base?: I): TenorSpec {
    return TenorSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TenorSpec>, I>>(object: I): TenorSpec {
    const message = createBaseTenorSpec()
    message.value = object.value ?? 0
    message.unit = object.unit ?? 0
    return message
  },
}

function createBaseMonthExpiry(): MonthExpiry {
  return { month: 0, year: undefined }
}

export const MonthExpiry: MessageFns<MonthExpiry> = {
  encode(message: MonthExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.month !== 0) {
      writer.uint32(8).uint32(message.month)
    }
    if (message.year !== undefined) {
      writer.uint32(16).uint32(message.year)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MonthExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMonthExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.month = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.year = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MonthExpiry {
    return {
      month: isSet(object.month) ? globalThis.Number(object.month) : 0,
      year: isSet(object.year) ? globalThis.Number(object.year) : undefined,
    }
  },

  toJSON(message: MonthExpiry): unknown {
    const obj: any = {}
    if (message.month !== 0) {
      obj.month = Math.round(message.month)
    }
    if (message.year !== undefined) {
      obj.year = Math.round(message.year)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MonthExpiry>, I>>(base?: I): MonthExpiry {
    return MonthExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MonthExpiry>, I>>(object: I): MonthExpiry {
    const message = createBaseMonthExpiry()
    message.month = object.month ?? 0
    message.year = object.year ?? undefined
    return message
  },
}

function createBaseWeekdayExpiry(): WeekdayExpiry {
  return { weekday: 0, weeksAhead: undefined }
}

export const WeekdayExpiry: MessageFns<WeekdayExpiry> = {
  encode(message: WeekdayExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.weekday !== 0) {
      writer.uint32(8).uint32(message.weekday)
    }
    if (message.weeksAhead !== undefined) {
      writer.uint32(16).uint32(message.weeksAhead)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WeekdayExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseWeekdayExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.weekday = reader.uint32()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.weeksAhead = reader.uint32()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): WeekdayExpiry {
    return {
      weekday: isSet(object.weekday) ? globalThis.Number(object.weekday) : 0,
      weeksAhead: isSet(object.weeksAhead)
        ? globalThis.Number(object.weeksAhead)
        : isSet(object.weeks_ahead)
          ? globalThis.Number(object.weeks_ahead)
          : undefined,
    }
  },

  toJSON(message: WeekdayExpiry): unknown {
    const obj: any = {}
    if (message.weekday !== 0) {
      obj.weekday = Math.round(message.weekday)
    }
    if (message.weeksAhead !== undefined) {
      obj.weeksAhead = Math.round(message.weeksAhead)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<WeekdayExpiry>, I>>(base?: I): WeekdayExpiry {
    return WeekdayExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<WeekdayExpiry>, I>>(object: I): WeekdayExpiry {
    const message = createBaseWeekdayExpiry()
    message.weekday = object.weekday ?? 0
    message.weeksAhead = object.weeksAhead ?? undefined
    return message
  },
}

function createBaseNearestExpiry(): NearestExpiry {
  return { minDays: undefined, maxDays: undefined }
}

export const NearestExpiry: MessageFns<NearestExpiry> = {
  encode(message: NearestExpiry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.minDays !== undefined) {
      writer.uint32(8).int64(message.minDays)
    }
    if (message.maxDays !== undefined) {
      writer.uint32(16).int64(message.maxDays)
    }
    return writer
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NearestExpiry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input)
    const end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseNearestExpiry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break
          }

          message.minDays = reader.int64().toString()
          continue
        }
        case 2: {
          if (tag !== 16) {
            break
          }

          message.maxDays = reader.int64().toString()
          continue
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skip(tag & 7)
    }
    return message
  },

  fromJSON(object: any): NearestExpiry {
    return {
      minDays: isSet(object.minDays)
        ? globalThis.String(object.minDays)
        : isSet(object.min_days)
          ? globalThis.String(object.min_days)
          : undefined,
      maxDays: isSet(object.maxDays)
        ? globalThis.String(object.maxDays)
        : isSet(object.max_days)
          ? globalThis.String(object.max_days)
          : undefined,
    }
  },

  toJSON(message: NearestExpiry): unknown {
    const obj: any = {}
    if (message.minDays !== undefined) {
      obj.minDays = message.minDays
    }
    if (message.maxDays !== undefined) {
      obj.maxDays = message.maxDays
    }
    return obj
  },

  create<I extends Exact<DeepPartial<NearestExpiry>, I>>(base?: I): NearestExpiry {
    return NearestExpiry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<NearestExpiry>, I>>(object: I): NearestExpiry {
    const message = createBaseNearestExpiry()
    message.minDays = object.minDays ?? undefined
    message.maxDays = object.maxDays ?? undefined
    return message
  },
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter
  decode(input: BinaryReader | Uint8Array, length?: number): T
  fromJSON(object: any): T
  toJSON(message: T): unknown
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T
}
